import React from 'react';
import { AuthLayoutStyled } from './auth-layout.styled';

interface Props {
  children: React.ReactNode;
}
const AuthLayout = (props: Props) => {
  return <AuthLayoutStyled>{props.children}</AuthLayoutStyled>;
};

export default AuthLayout;
